import { useCallback, useState } from 'react';
import { errorToReactLeft, pipe } from 'utils/fp';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { either } from 'fp-ts';
import { flex } from 'styles/utils';
import { cx } from '@linaria/core';
import { useQueryTE, useMutationTE, queryKeys } from 'utils/react-query';
import { useAuthState } from 'modules/Auth/AuthContext';
import { getUserMeTE, updateUserConsentTE } from 'api/users';
import { reactLeftToJSX } from 'utils/uiStates/uiStates';
import { useQueryClient } from 'react-query';
import { Button } from 'components/Button';
import { ContentMessage } from 'modules/Apps/components/ConsentCheckboxField';
import { wrapper, consentMessageWrapper, buttonWrapper } from './styles';

export const ConsentAcceptOverlay = ({ onCancelClick }: { onCancelClick?: () => void }): JSX.Element | null => {
  const queryClient = useQueryClient();
  const sessionToken = useAuthState().authData?.session_token;

  // DIRTY HACK TO PREVENT CLOSE ONBOARDING MODAL DIALOGS BECAUSE OF UPDATE PARENT COMPONENT WHICH OWNS MODALS
  const [randomKey] = useState(Math.random());
  const updateUserMutation = useMutationTE(() => pipe(updateUserConsentTE({ consent: true, fields: ['pii'] }, errorToReactLeft))(), {
    onMutate: () => {},
    onSettled: () => {},
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.LoggedInUser, { sessionToken, k: randomKey }]);
    },
    onError: ({ props }) => {
      cogoToast.error(props?.reason || 'Could not update the user consent', { heading: 'Error' });
    },
  });

  const handleConsentOnChange = useCallback(() => {
    updateUserMutation.mutate();
  }, []);

  const { data } = useQueryTE([queryKeys.LoggedInUser, { sessionToken, k: randomKey }], getUserMeTE(undefined, errorToReactLeft));

  return (
    <>
      {pipe(
        data,
        either.fold(reactLeftToJSX(), ({ user: { user_detail } }) =>
          user_detail?.date_pii_consent ? null : (
            <div className={wrapper}>
              <div className={consentMessageWrapper}>
                <ContentMessage />
                <div className={cx(buttonWrapper, onCancelClick ? flex.justifyContent.between : flex.justifyContent.end)}>
                  {onCancelClick && (
                    <Button
                      data-testid="cancel-consest-button"
                      className="action"
                      variant="secondary"
                      onClick={onCancelClick}
                      type="submit"
                      disabled={updateUserMutation.isLoading}
                    >
                      Cancel
                    </Button>
                  )}
                  <Button
                    data-testid="agree-consest-button"
                    className="action"
                    variant="primary"
                    onClick={handleConsentOnChange}
                    type="submit"
                    disabled={updateUserMutation.isLoading}
                  >
                    I agree
                  </Button>
                </div>
              </div>
            </div>
          ),
        ),
      )}
    </>
  );
};
